'use client';

export { default } from './SvgIcon';
export { default as svgIconClasses } from './svgIconClasses';
export * from './svgIconClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SvgIcon/index.js
// module id = 310
// module chunks = 25